/**
 * Shared click-tracking helper for Algolia conversion events.
 *
 * Attaches a delegated click listener to a container element that:
 *  1. Reads hit data from a lookup map keyed by product handle
 *  2. Fetches the queryID from the InstantSearch helper
 *  3. Writes to the AlgoliaAutocompleteObjectQueryCache in localStorage
 *  4. Prunes cache entries older than 7 days
 *
 * @param {Object} opts
 * @param {string} opts.containerSelector - CSS selector for the hits container (e.g. '#ais-hits')
 * @param {string} opts.cardSelector      - CSS selector for individual product cards (e.g. '.ais-product-card[data-handle]')
 * @param {Object} opts.hitsByHandle      - Reference to the mutable map { handle: { objectID, shopifyProductID } }
 * @param {Object} opts.search            - The InstantSearch instance (used to read search.helper.lastResults.queryID)
 * @param {string} opts.indexName         - The Algolia index name to store in the cache
 */
(function () {
  var CACHE_KEY = 'AlgoliaAutocompleteObjectQueryCache';
  var WEEK_MS = 7 * 24 * 60 * 60 * 1000;

  window.algoliaClickTracking = function (opts) {
    var container = document.querySelector(opts.containerSelector);
    if (!container) return;

    container.addEventListener('click', function (e) {
      var productCard = e.target.closest(opts.cardSelector);
      if (!productCard) return;

      var handle = productCard.getAttribute('data-handle');
      var hitData = opts.hitsByHandle[handle];
      if (!hitData) return;

      var queryID =
        opts.search.helper &&
        opts.search.helper.lastResults &&
        opts.search.helper.lastResults.queryID;
      if (!queryID) return;

      var cache = {};
      try {
        var existing = localStorage.getItem(CACHE_KEY);
        if (existing) cache = JSON.parse(existing);
      } catch (err) {}

      // Prune entries older than 7 days
      var now = Date.now();
      Object.keys(cache).forEach(function (k) {
        if (Array.isArray(cache[k]) && cache[k][1] < now - WEEK_MS) delete cache[k];
      });

      cache[hitData.objectID] = [queryID, now, opts.indexName, hitData.shopifyProductID];
      localStorage.setItem(CACHE_KEY, JSON.stringify(cache));
    });
  };
})();
